import {webFont} from "../../config/theme";

export default {
    error: {
        fontSize: 14,
        color: 'red',
        fontFamily: webFont,
        margin: 0,
    },
    labelText: {
        fontSize: 14,
        textAlign: 'left',
        margin: 0,
        marginTop: 5,
        fontFamily: webFont,
        fontWeight: '500',
    },
    switchLabelText: {
        fontSize: 18,
        textAlign: 'left',
        margin: '0',
        fontFamily: webFont,
        lineHeight:'normal'
    },
    fieldContainer: {
        paddingTop: 32,
        paddingBottom: 13
    }
}